// Copyright (c) Docugami, Inc. All rights reserved.

import { OAuthRequestStatus } from "networking/Authentication";

export function isActiveAuthenticationStatus(status: OAuthRequestStatus) {
    return status === OAuthRequestStatus.Initiated || status === OAuthRequestStatus.Authorizing;
}

export function isCompleteAuthenticationStatus(status: OAuthRequestStatus) {
    return status === OAuthRequestStatus.Succeeded ||
        status === OAuthRequestStatus.Failed ||
        status === OAuthRequestStatus.Timeout;
}
